import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Form } from 'react-final-form';

import CardWrapper, { EDIT_PROJECT_SECTION } from '../../../card-wrapper/CardWrapper';
import AssignedAssistantsForm from './AssignedAssistantsForm';
import { changeScoutProjectAccessAssistants, getAccessAssistants } from '../../../../../redux/projects/projectsActions';
import { ASSISTANTS_CATEGORY } from '../../../../../constants';
import validate from '../../../../../utils/validate';
import { editScoutAssistantsYupValidation } from './validation';

function AssignedAssistantsSection() {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();
  const { id } = useParams();

  const editProject = useSelector((state) => state.projects.editProject);

  const accessAssistantsInitialValues = {
    activeAllAssistants: getAssistantsOptionsByCategory(editProject?.assistantData, ASSISTANTS_CATEGORY.GENERATE_ALL),
    activeSelectedAssistants: getAssistantsOptionsByCategory(
      editProject?.assistantData,
      ASSISTANTS_CATEGORY.GENERATE_SELECTED,
    ),
    activeCompressAssistants: getAssistantsOptionsByCategory(editProject?.assistantData, ASSISTANTS_CATEGORY.COMPRESS),
  };

  const handleChangeAccessAssistants = ({
    activeAllAssistants,
    activeSelectedAssistants,
    activeCompressAssistants,
  }) => {
    dispatch(
      changeScoutProjectAccessAssistants({
        id,
        activeAllAssistants,
        activeSelectedAssistants,
        activeCompressAssistants,
      }),
    );
  };

  useEffect(() => {
    dispatch(getAccessAssistants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CardWrapper label={t('assignedAssistants')} sectionType={EDIT_PROJECT_SECTION.ASSIGNED_ASSISTANTS}>
      <Form
        initialValues={accessAssistantsInitialValues}
        onSubmit={handleChangeAccessAssistants}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, editScoutAssistantsYupValidation())}
        render={({ handleSubmit }) => (
          <AssignedAssistantsForm onSubmit={handleSubmit} initialValues={accessAssistantsInitialValues} />
        )}
      />
    </CardWrapper>
  );
}

export default AssignedAssistantsSection;

const getAssistantsOptionsByCategory = (assistantData = {}, assistantCategory = ASSISTANTS_CATEGORY.GENERATE_ALL) => {
  if (!Object.keys(assistantData).length) {
    return [];
  }

  return (
    assistantData?.[assistantCategory]?.map((assistant) => ({
      ...assistant,
      value: assistant.id,
      label: assistant.name,
    })) || []
  );
};
